import React from 'react';
import classNames from 'classnames/bind';
import styles from './index.less';
const cx = classNames.bind(styles);

interface ScoreItem {
  label?: string;
  score?: number; // 分数
  weight?: number; // 权重百分比，如 20 表示 20%
}

type TotalScoreBannerTheme = 'light' | 'dark';

interface TotalScoreBannerProps {
  totalScore?: number; // 总分
  totalScoreLabel?: string; // 总分的标题，默认为"总分"
  scoreItems?: ScoreItem[]; // 评分项数组
  theme?: TotalScoreBannerTheme; // 主题：'light' 浅色主题（浅紫色背景），'dark' 深色主题（深紫色背景）
  className?: string;
  style?: React.CSSProperties;
}

/**
 * 总分计算横幅组件
 * 显示总分和各个加权评分项
 * 支持两种主题：浅色（浅紫色背景）和深色（深紫色背景）
 */
const TotalScoreBanner: React.FC<TotalScoreBannerProps> = ({
  totalScore,
  totalScoreLabel = '总分',
  scoreItems,
  theme = 'light',
  className = '',
  style,
}) => {
  // 安全格式化为保留两位小数：先尝试转换为 number，仅当为有限数字时格式化，否则返回 '-'
  const formatScore = (value: unknown): string => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    const num = typeof value === 'number' ? value : Number(value);
    if (Number.isFinite(num)) {
      return num.toFixed(2);
    }
    return '-';
  };

  return (
    <div className={cx('total-score-banner', `total-score-banner-${theme}`, className)} style={style}>
      {/* 总分 */}
      <div className={cx('total-score-section')}>
        <div className={cx('label')}>{totalScoreLabel}</div>
        <div className={cx('value')}>{formatScore(totalScore)}</div>
      </div>

      {/* 等号 */}
      <div className={cx('equals-sign')}>=</div>

      {/* 评分项 */}
      {scoreItems
        ?.filter((item): item is ScoreItem => item !== undefined)
        ?.map((item, index, filteredItems) => (
          <React.Fragment key={index}>
            <div className={cx('score-item')}>
              <div className={cx('label')}>{item.label}</div>
              <div className={cx('value')}>
                <span className={cx('score-number')}>{formatScore(item.score)}</span>
                <span className={cx('score-weight')}>&nbsp;×&nbsp;{item.weight}%</span>
              </div>
            </div>
            {index < filteredItems.length - 1 && (
              <div className={cx('plus-sign')}>+</div>
            )}
          </React.Fragment>
        ))}
    </div>
  );
};

export default TotalScoreBanner;